import React, { useContext, useState } from 'react';
import ContentBox from '../components/ContentBox';
import { FlexColumn, FlexRow } from '../layouts';
import { Header, Segment, Label, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { SettingsContext } from '../providers/SettingsProvider';
import SetRepositoryModal from '../components/SetRepositoryModal';
import moment from 'moment/moment';

export interface ISettings {}

const Settings = (_props: ISettings) => {
  const { settingsData, onPublish, onSetRepository } =
    useContext(SettingsContext);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSetRepository = () => {
    setOpen(true);
  };

  const handlePublish = () => {
    onPublish(`Publishing ${moment().format()}`);
  };

  const handleSubmitRepository = (url: string) => {
    setOpen(false);
    onSetRepository(url);
  };

  return (
    <ContentBox widthPct={100} heightPct={35} padding={32}>
      <FlexRow alignLeftCenter>
        <FlexColumn>
          <Header as="h3">{t('settings.gitSettings')}</Header>
          <Segment>
            <Label attached="top">{t('settings.remoteRepositoryUrl')}</Label>
            <Segment padded>
              {settingsData?.remoteRepositoryURL ||
                t('settings.noRepositorySpecified')}
            </Segment>
            <Button onClick={handleSetRepository} primary>
              {t('settings.setRemoteRepository')}
            </Button>
          </Segment>
        </FlexColumn>
        <FlexRow padLeft={32} height={40}>
          <Button
            onClick={handlePublish}
            disabled={!settingsData?.canPublish}
            primary
          >
            {t('settings.publish')}
          </Button>
        </FlexRow>
      </FlexRow>
      <SetRepositoryModal
        open={open}
        currentUrl={settingsData?.remoteRepositoryURL}
        onSubmit={handleSubmitRepository}
        onCancel={() => setOpen(false)}
      />
    </ContentBox>
  );
};

export default Settings;
